<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { staticClass: "wallet Withdraw" },
    [
      _c(
        "div",
        { staticClass: "d-flex justify-content-start align-items-center mb-1" },
        [
          _c(
            "h3",
            { staticClass: "mb-0 back_button" },
            [
              _c("BackButton"),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("transactionHistory.Withdraw"))),
              ]),
            ],
            1
          ),
        ]
      ),
      _c("div", [
        _c(
          "div",
          [
            _c("validation-observer", {
              ref: "cerateWithdraw",
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    return [
                      _c(
                        "b-form",
                        {
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.cerateWithdraw($event)
                            },
                          },
                        },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "6" } },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "pl-0 pr-0",
                                      attrs: { md: "12" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "text-lable mb-1" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("wallet.Select-Coin")
                                              ) +
                                              " "
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "red-star" },
                                            [_vm._v("*")]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "col-20-p" },
                                        [
                                          _c("validation-provider", {
                                            attrs: {
                                              name: _vm.$t(
                                                "wallet.Select-Coin"
                                              ),
                                              rules: "required",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (ref) {
                                                    var errors = ref.errors
                                                    return [
                                                      _c(
                                                        "CurrencySelectObject",
                                                        {
                                                          staticClass:
                                                            "min-drop mb-1",
                                                          attrs: {
                                                            name: _vm.$t(
                                                              "wallet.Select-Coin"
                                                            ),
                                                            autocomplete: "off",
                                                            clearable: false,
                                                            options: _vm.coins,
                                                          },
                                                          model: {
                                                            value: _vm.coin,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.coin = $$v
                                                            },
                                                            expression: "coin",
                                                          },
                                                        }
                                                      ),
                                                      _c("Errors", {
                                                        attrs: {
                                                          error: errors[0],
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "pl-0 pr-0",
                                      attrs: { md: "12" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "text-lable mb-1 mt-1" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("wallet.Network")) +
                                              " "
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "red-star" },
                                            [_vm._v("*")]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        [
                                          _c("validation-provider", {
                                            attrs: {
                                              name: _vm.$t("wallet.Network"),
                                              rules: "required",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (ref) {
                                                    var errors = ref.errors
                                                    return [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          disabled: "",
                                                          placeholder:
                                                            _vm.$t(
                                                              "wallet.Network"
                                                            ),
                                                        },
                                                        model: {
                                                          value: _vm.network,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.network = $$v
                                                          },
                                                          expression: "network",
                                                        },
                                                      }),
                                                      _c("Errors", {
                                                        attrs: {
                                                          error: errors[0],
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                          _vm.coin &&
                                          _vm.coin.contractAddress &&
                                          _vm.coin.contractAddress.length
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "placeholder-below-text d-flex justify-content-end",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "wallet.ContractAddress"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                    _c("b", [
                                                      _vm._v(
                                                        "***" +
                                                          _vm._s(
                                                            _vm.coin.contractAddress.slice(
                                                              -4
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "pl-0 pr-0",
                                      attrs: { md: "12" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "text-lable mb-1",
                                          class:
                                            !_vm.coin ||
                                            !_vm.coin.contractAddress
                                              ? "mt-1"
                                              : "",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("wallet.WithdrawAddress")
                                              ) +
                                              " "
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "red-star" },
                                            [_vm._v("*")]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "mb-2" },
                                        [
                                          _c("validation-provider", {
                                            attrs: {
                                              name: _vm.$t(
                                                "wallet.WithdrawAddress"
                                              ),
                                              rules: "required|txAddress",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (ref) {
                                                    var errors = ref.errors
                                                    return [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          placeholder: _vm.$t(
                                                            "wallet.WithdrawAddress"
                                                          ),
                                                        },
                                                        model: {
                                                          value: _vm.toAddress,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.toAddress = $$v
                                                          },
                                                          expression:
                                                            "toAddress",
                                                        },
                                                      }),
                                                      _c("Errors", {
                                                        attrs: {
                                                          error: errors[0],
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _vm.coin && _vm.coin.id
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass: "pl-0 pr-0",
                                          attrs: { md: "12" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-lable mb-1 mt-1 d-flex justify-content-between",
                                            },
                                            [
                                              _c("div", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t("wallet.Amount")
                                                    ) +
                                                    " "
                                                ),
                                                _c(
                                                  "span",
                                                  { staticClass: "red-star" },
                                                  [_vm._v("*")]
                                                ),
                                              ]),
                                              _c(
                                                "b",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: false,
                                                      expression: "false",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "placeholder-below-text mt-0",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "wallet.remainingLimit"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            [
                                              _c("validation-provider", {
                                                attrs: {
                                                  name: _vm.$t("wallet.Amount"),
                                                  rules: {
                                                    required: true,
                                                    minAmountQuantity:
                                                      _vm.coin.minWithdraw,
                                                    maxAmountQuantity:
                                                      _vm.availableBalance,
                                                  },
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (ref) {
                                                        var errors = ref.errors
                                                        return [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group",
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-input",
                                                                {
                                                                  staticClass:
                                                                    "form-control you-amount",
                                                                  staticStyle: {
                                                                    "text-align":
                                                                      "left",
                                                                    "padding-right":
                                                                      "17px",
                                                                  },
                                                                  attrs: {
                                                                    placeholder:
                                                                      "0.00",
                                                                  },
                                                                  on: {
                                                                    keypress:
                                                                      _vm.validateKeyPress,
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.quantity,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.quantity =
                                                                          $$v
                                                                      },
                                                                    expression:
                                                                      "quantity",
                                                                  },
                                                                }
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "input-group-prepend",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "input-group-text you-max pointer",
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.setMaxAmount()
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "wallet.MAX"
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "input-group-append",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "input-group-text you-buy-input",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                _vm
                                                                                  .coin
                                                                                  .id
                                                                              )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c("Errors", {
                                                            attrs: {
                                                              error: errors[0],
                                                            },
                                                          }),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "placeholder-below-text d-flex justify-content-end",
                                                },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.availableBalance +
                                                          " " +
                                                          _vm.coin.id
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.coin
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass: "pl-0 pr-0",
                                          attrs: { md: "12" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "text-lable mt-1" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("wallet.NetworkFee")
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c("div", [
                                            _c("div", { staticClass: "amt" }, [
                                              _c(
                                                "span",
                                                { staticClass: "amt-usdt" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.fee +
                                                        " " +
                                                        _vm.coin.id
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.coin
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass: "pl-0 pr-0",
                                          attrs: { md: "12" },
                                        },
                                        [
                                          _c("div", [
                                            _c(
                                              "div",
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-lable mt-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "wallet.ReceiveAmount"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex justify-content-between align-items-cente rrcy",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "you-get amt",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.amount +
                                                                " " +
                                                                _vm.coin.id
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "btn-icon Withdraw-btn mt-1",
                                                    attrs: {
                                                      variant: "primary",
                                                      type: "submit",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "align-middle",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "wallet.Withdraw"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c("b-col", { attrs: { md: "6" } }, [
                                _c("div", { staticClass: "fqa" }),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
      _c(
        "div",
        [
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-start align-items-center mb-1 mt-3",
            },
            [
              _c(
                "div",
                { staticClass: "d-flex justify-content-between w-100" },
                [
                  _c("div", [
                    _c("h3", [
                      _vm._v(_vm._s(_vm.$t("wallet.RecentWithdrawals"))),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "refresh-button" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "btn-icon",
                          attrs: { variant: "flat-primary" },
                          on: { click: _vm.getAllTransactionHistory },
                        },
                        [
                          _c("feather-icon", {
                            attrs: { icon: "RotateCwIcon" },
                          }),
                          _c("span", { staticClass: "align-middle ml-1" }, [
                            _vm._v(_vm._s(_vm.$t("wallet.Refresh"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
          _c("b-table", {
            attrs: {
              items: _vm.items,
              "show-empty": "",
              fields: _vm.fields,
              responsive: "",
            },
            scopedSlots: _vm._u([
              {
                key: "cell(toAddress)",
                fn: function (data) {
                  return [
                    _c(
                      "b-link",
                      { staticClass: "no-wrap" },
                      [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.v-primary",
                                modifiers: { hover: true, "v-primary": true },
                              },
                            ],
                            staticClass: "mr-1",
                            attrs: { title: data.value },
                          },
                          [_vm._v(_vm._s(data.item.toAddressStr))]
                        ),
                        _c("copy", {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover.v-primary",
                              modifiers: { hover: true, "v-primary": true },
                            },
                          ],
                          attrs: { title: _vm.$t("wallet.Copy") },
                          on: {
                            click: function ($event) {
                              return _vm.copy(data.value)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "cell(txId)",
                fn: function (data) {
                  return [
                    data.value
                      ? _c(
                          "b-link",
                          { staticClass: "no-wrap" },
                          [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover.v-primary",
                                    modifiers: {
                                      hover: true,
                                      "v-primary": true,
                                    },
                                  },
                                ],
                                staticClass: "mr-1",
                                attrs: { title: data.value },
                              },
                              [_vm._v(_vm._s(data.item.txIdStr))]
                            ),
                            _c("copy", {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover.v-primary",
                                  modifiers: { hover: true, "v-primary": true },
                                },
                              ],
                              attrs: { title: _vm.$t("wallet.Copy") },
                              on: {
                                click: function ($event) {
                                  return _vm.copy(data.value)
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-center justify-content-sm-end",
                  attrs: { cols: "12", sm: "12" },
                },
                [
                  _vm.items.length
                    ? _c(
                        "b-link",
                        {
                          staticClass: "textDecoration",
                          on: {
                            click: function ($event) {
                              return _vm.$router.push({
                                path: "transactionHistory",
                                params: { lang: _vm.lang || undefined },
                              })
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("wallet.ViewMore>>")) + " "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("ConfirmOrderPop", {
        attrs: {
          showPop: _vm.showConfirmPop,
          data: _vm.orderData,
          onModalHidden: _vm.toggleConfirmPop,
          apiCall: _vm.apiCall,
          buttonText: _vm.buttonText,
        },
      }),
      _c("SecurityVerification", {
        attrs: {
          showVerificationPop: _vm.showVerificationPop,
          submitVerification: _vm.assetWithdraw,
          onModalHidden: _vm.toggleSecurityVerification,
          ConfirmResendText: _vm.ConfirmResendText,
          ConfirmPlaceholder: _vm.ConfirmPlaceholder,
          resendData: _vm.resendData,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/views/wallet/Withdraw.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import vue_select from 'vue-select';
import assets_rashi_coin_copy_svg from '@/assets/rashi-coin/copy.svg';
import libs_api_api from '@/libs/api/api';
import core_components_toastification_ToastificationContent_vue from '@core/components/toastification/ToastificationContent.vue';
import * as vuex from 'vuex';
import * as veevalidate from 'vee-validate';
import layouts_components_CurrencySelectObject_vue from '@/layouts/components/CurrencySelectObject.vue';
import layouts_components_DatePicker_vue from '@/layouts/components/DatePicker.vue';
import utils_clipboard from '@/utils/clipboard';
import validations from '@validations';
import utils_constants from '@/utils/constants';
import layouts_components_BackButton_vue from '@/layouts/components/BackButton.vue';
import layouts_components_CancelOrder_ConfirmOrderPop_vue from '@/layouts/components/CancelOrder/ConfirmOrderPop.vue';
import layouts_components_SecurityVerification_vue from '@/layouts/components/SecurityVerification.vue';
import layouts_components_Errors_vue from '@/layouts/components/Errors.vue';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















export default ({
  render,
  staticRenderFns,
  components: {
    BLink: bootstrapvue["BLink"],
    BRow: bootstrapvue["BRow"],
    BCol: bootstrapvue["BCol"],
    BContainer: bootstrapvue["BContainer"],
    BCard: bootstrapvue["BCard"],
    BTable: bootstrapvue["BTable"],
    BButton: bootstrapvue["BButton"],
    BFormGroup: bootstrapvue["BFormGroup"],
    BAvatar: bootstrapvue["BAvatar"],
    BBadge: bootstrapvue["BBadge"],
    vSelect: vue_select,
    BFormInput: bootstrapvue["BFormInput"],
    BDropdown: bootstrapvue["BDropdown"],
    BInputGroup: bootstrapvue["BInputGroup"],
    BInputGroupText: bootstrapvue["BInputGroupText"],
    BDropdownItem: bootstrapvue["BDropdownItem"],
    BInputGroupPrepend: bootstrapvue["BInputGroupPrepend"],
    BInputGroupAppend: bootstrapvue["BInputGroupAppend"],
    BFormDatepicker: bootstrapvue["BFormDatepicker"],
    copy: assets_rashi_coin_copy_svg,
    BPagination: bootstrapvue["BPagination"],
    CurrencySelectObject: layouts_components_CurrencySelectObject_vue,
    DatePicker: layouts_components_DatePicker_vue,
    ValidationProvider: veevalidate["ValidationProvider"],
    ValidationObserver: veevalidate["ValidationObserver"],
    BForm: bootstrapvue["BForm"],
    BackButton: layouts_components_BackButton_vue,
    ConfirmOrderPop: layouts_components_CancelOrder_ConfirmOrderPop_vue,
    SecurityVerification: layouts_components_SecurityVerification_vue,
    Errors: layouts_components_Errors_vue
  },
  directives: {
    "b-tooltip": bootstrapvue["VBTooltip"]
  },
  data() {
    return {
      fields: [{
        key: "createdTime",
        label: this.$t("Order.CreateTime")
      }, {
        key: "txType",
        label: this.$t("transactionHistory.Type")
      }, {
        key: "coin",
        label: this.$t("transactionHistory.Coin")
      }, {
        key: "totalAmount",
        label: this.$t("transactionHistory.Amount")
      }, {
        key: "toAddress",
        label: this.$t("transactionHistory.Destination")
      }, {
        key: "txId",
        label: this.$t("transactionHistory.TxId")
      }, {
        key: "txStatus",
        label: this.$t("transactionHistory.Status")
      }],
      items: [],
      coin: null,
      page: 1,
      size: 10,
      lang: this.$route.params.lang,
      isPaginationVisible: false,
      totalRows: 0,
      quantity: "",
      text: "",
      toAddress: "",
      availableBalance: 0,
      txAddress: validations["txAddress"],
      required: validations["required"],
      maxAmountQuantity: validations["maxAmountQuantity"],
      network: "",
      amount: 0,
      fee: 0,
      minAmountQuantity: validations["minAmountQuantity"],
      title: "",
      subTitle: "",
      buttonText: "",
      type: "",
      showConfirmPop: false,
      showVerificationPop: false,
      orderData: {},
      ConfirmResendText: "",
      ConfirmPlaceholder: "",
      resendData: {}
    };
  },
  computed: {
    ...vuex.mapState("user", ["refData", "user", "coins"])
  },
  mounted() {
    if (this.$route && this.$route.query && this.$route.query.coin) {
      this.coin = {
        id: this.$route.query.coin || "",
        network: this.$route.query.network || ""
      };
    }
    this.getAllTransactionHistory();
  },
  watch: {
    quantity(newVal) {
      this.fee = this.coin.withdrawFee;
      if (newVal && newVal > 0) {
        this.amount = parseFloat((newVal - this.fee).toFixed(this.refData.coinDecimal || coinDecimal));
      } else {
        this.amount = 0;
      }
    },
    size() {
      if (!this.size) {
        this.size = 10;
      }
      this.getAllTransactionHistory();
    },
    page() {
      // setPagination.apply(this, [`${this.page}`]);
      this.getAllTransactionHistory();
    },
    coin(newVal, oldVal) {
      this.network = newVal.network;
      if (!oldVal || newVal.id != oldVal.id) {
        this.getBalance();
      }
    }
  },
  methods: {
    validateKeyPress(event) {
      const key = event.key;
      if (!/^\d$/.test(key) && key !== "." && key !== "Backspace") {
        event.preventDefault();
      } else {}
    },
    toggleConfirmPop(flag) {
      this.showConfirmPop = flag;
      if (flag) {
        this.orderData = {
          coin: this.coin.id,
          network: this.coin.network,
          quantity: this.quantity,
          toAddress: this.toAddress,
          amount: this.amount,
          fee: this.fee
        };
        this.buttonText = this.$t("wallet.WithdrawPopButtonText");
      } else if (!flag) {
        this.orderData = {};
      }
    },
    toggleSecurityVerification(flag) {
      this.showVerificationPop = flag;
      if (!flag) {
        this.resendData = {};
      }
    },
    apiCall() {
      this.toggleConfirmPop(false);
      this.toggleSecurityVerification(true);
      this.resendData = {
        coin: this.coin.id,
        network: this.coin.network,
        quantity: this.quantity,
        toAddress: this.toAddress,
        amount: this.amount,
        fee: this.fee
      };
      if (this.user && !this.user.totpLinked) {
        this.ConfirmPlaceholder = this.$t("wallet.PleaseEnterTheEmailOtp");
        this.ConfirmResendText = this.$t("wallet.ResendCode");
        this.sendOtp();
      }
    },
    setMaxAmount() {
      this.quantity = this.availableBalance;
    },
    async cerateWithdraw() {
      this.$refs.cerateWithdraw.validate().then(success => {
        if (success) {
          this.toggleConfirmPop(true);
          // this.assetWithdraw();
        }
      });
    },
    async copy(text) {
      await utils_clipboard.apply(this, [`${text}`]);
    },
    customSort(a, b, key, order) {
      if (key != this.field && order != this.order) {
        this.order = order;
        this.field = key;
      }
    },
    async sendOtp() {
      try {
        const res = await new libs_api_api().api({
          method: "POST",
          url: `auth/sendOTP`
        }, {
          type: "WITHDRAW",
          coin: this.coin.id,
          amount: this.quantity,
          address: this.toAddress
        }, {
          isLoading: true
        });
        if (res && res.result && res.result.requestStatus == "SUCCESS") {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: this.$t("security.VerificationCodeSendSuccessfully"),
              icon: "EditIcon",
              variant: "success"
            }
          });
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
    },
    async getAllTransactionHistory() {
      try {
        const res = await new libs_api_api().api({
          method: "GET",
          url: `asset/tx/search`
        }, {
          page: this.page,
          size: this.size,
          txType: "WITHDRAW"
        }, {
          isLoading: true
        });
        if (res && res.cryptoTxList) {
          this.items = res.cryptoTxList.map(item => {
            return {
              ...item,
              createdTime: utils_constants.dateFormat(item.createdTime),
              txIdStr: utils_constants.showOnlyLastFiveChar(item.txId),
              toAddressStr: utils_constants.showOnlyLastFiveChar(item.toAddress)
            };
          });
          this.totalRows = res.count;
          if (res.count && res.count > this.size) {
            this.isPaginationVisible = true;
          } else {
            this.isPaginationVisible = false;
          }
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
    },
    async getBalance() {
      try {
        if (this.coin && this.coin.id) {
          const res = await new libs_api_api().api({
            method: "GET",
            url: `asset/balance`
          }, {
            asset: this.coin.id
          }, {
            isLoading: true
          });
          if (res && res.availableBalance) {
            this.availableBalance = res.availableBalance;
            // this.availableBalance = res.totalBalance;
          } else if (res && res.error && res.error.message) {
            this.$toast({
              component: core_components_toastification_ToastificationContent_vue,
              props: {
                title: res.error.message,
                icon: "EditIcon",
                variant: "danger"
              }
            });
          }
        } else {
          this.availableBalance = 0;
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
    },
    async resetAllFields() {
      this.quantity = 0;
      this.amount = 0;
      this.toAddress = "";
    },
    async assetWithdraw(code) {
      try {
        const res = await new libs_api_api().api({
          method: "POST",
          url: `asset/send`
        }, {
          coin: this.coin.id,
          amount: this.quantity,
          toAddress: this.toAddress,
          code: code || undefined
        }, {
          isLoading: true
        });
        if (res && res.result && res.result.requestStatus == "SUCCESS") {
          this.toggleSecurityVerification(false);
          this.getAllTransactionHistory();
          this.$router.push({
            path: `transactionHistory`,
            params: {
              lang: this.lang || undefined
            }
          });
          await this.getBalance();
          this.resetAllFields();
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: this.$t("wallet.withdrawRequestCreatedSuccessfully"),
              icon: "EditIcon",
              variant: "success"
            }
          });
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
    }
  }
});

//# sourceURL=webpack:///./src/views/wallet/Withdraw.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style scoped>
.p2p-filter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.p2p-filter .filter-area {
  display: flex;
  align-items: center;
}
[dir] .p2p-filter .filter-area .vs--single .vs__dropdown-toggle {
  padding: 2px;
}
[dir=ltr] .p2p-filter .filter-area .vs__actions {
  padding: 0px 6px 0 3px;
}
[dir=rtl] .p2p-filter .filter-area .vs__actions {
  padding: 0px 3px 0 6px;
}
.p2p-filter .filter-area .col-20-p {
  min-width: 210px;
}
[dir=ltr] .p2p-filter .filter-area .col-20-p {
  padding-right: 15px;
}
[dir=rtl] .p2p-filter .filter-area .col-20-p {
  padding-left: 15px;
}
.p2p-filter .filter-area .col-20-p .min-drop.v-select {
  min-width: 200px;
}
[dir=ltr] .p2p-filter .refresh-btn {
  text-align: right;
}
[dir=rtl] .p2p-filter .refresh-btn {
  text-align: left;
}
.content1 {
  color: #8dc540;
  font-size: 34px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 2.38px;
}
.h4 {
  color: var(--text-black-color);
  font-size: 21px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 1.47px;
}
[dir] .h4 {
  margin: 16px 0px 16px 0px;
}
.amt {
  color: var(--text-black-color);
  font-size: 19px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 1.33px;
}
.Search {
  color: #6e6b7b;
  font-size: 16px;
  font-weight: 400;
}
.text-lable {
  color: #7f7f7f;
  font-size: 13.234px;
  font-weight: 500;
  line-height: 10px;
}
[dir] .placeholder-below-text {
  margin-top: 5px;
}
.amt-usdt {
  color: #8e8c8c;
  font-size: 17px;
  font-weight: 600;
  line-height: 42px;
}
.you-get {
  font-size: 22px;
  font-weight: 600;
  line-height: 42px;
}
.Withdraw-btn {
  min-width: 150px;
}
.Send {
  color: var(--text-black-color);
  font-weight: bold;
}
[dir] .Send {
  margin: 15px 0px 15px 0px;
}
[dir=ltr] .you-amount {
  border-right: none !important;
}
[dir=rtl] .you-amount {
  border-left: none !important;
}
.you-max {
  color: var(--primary);
}
[dir=ltr] .you-max {
  border-left: none !important;
  border-right: 3px solid #d8d6de !important;
}
[dir=rtl] .you-max {
  border-right: none !important;
  border-left: 3px solid #d8d6de !important;
}
[dir=ltr] .dark-layout .you-max {
  border-right: 3px solid #404656 !important;
}
[dir=rtl] .dark-layout .you-max {
  border-left: 3px solid #404656 !important;
}
[dir] .rrcy {
  margin-top: 5px;
}
</style>
